import React, { useState } from "react";
import { useEffect } from "react";
import {Table as AntTable,Button,Col,Form,Input,message,notification,Modal,Popconfirm,Row,Switch,Tag} from "antd";
// import CustomerRequest from "./CustomerRequest";
import Table, { ColumnsType } from "antd/es/table";
import { Link, useNavigate } from "react-router-dom";
import { components, getRowClassName } from "../../utils/utils";
import IMAGES from "../../const/Image";
import Search from "antd/es/input/Search";
import { GetLoggedInUser } from "../../utils/utils";
// import { CustomersFilter } from "./CustomersFilter";
import { FaSliders } from "react-icons/fa6";
import { Space, Tooltip } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import CouponsRequest from "./CouponsRequest";
import { usePermission } from "../../hooks/usePermission";
const initialFilter = {
  page: 1,
};


const CouponsList = () => {
  const hasListPermission = usePermission("Coupons", "List");
  // console.log('Has list permission:', hasListPermission);
  const hasAddPermission = usePermission("Coupons", "Add");
  const hasEditPermission = usePermission("Coupons", "Edit");
  const hasDeletePermission = usePermission("Coupons", "Delete");

  const [form] = Form.useForm();
  const navigate = useNavigate();
  const showConfirm = Modal.confirm;
  const [loading, setLoading] = useState(false);
  const [labList, setLabList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterForm, setFilterForm] = useState({});
  const [filter, setFilter] = useState(initialFilter);
  const [filteredCoupons, setFilteredCoupons] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // let LOG_IN_USER = GetLoggedInUser();
  const user = GetLoggedInUser();
// console.log('User permissions:', user?.permissions);
// console.log('Coupons permission:', user?.permissions?.Coupons);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const fetchCouponList = () => {
    setLoading(true);
    CouponsRequest.couponList(filter)
      .then((response) => {
        const rawData = response?.data?.data?.data || [];
        console.log(rawData, "data");
        setLabList(rawData);
        setFilteredCoupons(rawData);
        setTotalRecords(response?.data?.data?.totalItems || rawData.length);
      })
      .catch((error) => {
        // message.error("Failed to fetch customers.");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    // fetchCouponList();
       if (hasListPermission) {
      fetchCouponList();
    }
  }, [filter,hasListPermission]);

  const handleFilter = (value) => {
    setFilter({ ...filter, ...filterForm, ...initialFilter });
    console.log("filter", filter);
    setIsModalOpen(false);
  };

  const handleStatusChange = (checked, item) => {
    showConfirm({
      title: `Are you sure you want to ${
        checked ? "activate" : "deactivate"
      } this Coupon?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        setLoading(true);
        CouponsRequest.updateCouponStatus({
          status: checked ? 1 : 0,
          couponId: item.id,
        })
          .then((res) => {
            if (res && res.status === 200) {
              notification.success({
                message: "Status updated successfully",
              });
              setLabList((prevList) =>
                prevList.map((el) =>
                  el.couponId === item.couponId
                    ? { ...el, is_active: checked ? "1" : "0" }
                    : el
                )
              );
              fetchCouponList();
            } else {
              notification.error({
                message: "Failed to update status",
              });
            }
          })
          .catch(() => {
            notification.error({
              message: "Failed to update status",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      },
    });
  };

  // const handleDelete = (couponId) => {
  //   setLoading(true);
  //   CouponsRequest.deleteCoupon(couponId)
  //     .then(() => {
  //       message.success("coupon deleted successfully");
  //       setLabList((prevList) =>
  //         prevList.filter((item) => item.couponId !== couponId)
  //       );
  //       navigate(0, { state: { refresh: true } });
  //     })
  //     .catch((error) => {
  //       message.error("Failed to delete category");
  //       console.error(error);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };


   const handleDelete = (couponId) => {
    if (!hasDeletePermission) {
      notification.error({
        message: "You don't have permission to delete coupons",
      });
      return;
    }

    setLoading(true);
    CouponsRequest.deleteCoupon(couponId)
      .then(() => {
        message.success("Coupon deleted successfully");
        setLabList((prevList) =>
          prevList.filter((item) => item.couponId !== couponId)
        );
        navigate(0, { state: { refresh: true } });
      })
      .catch((error) => {
        message.error("Failed to delete coupon");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const columns = (navigate) => [
    {
      title: "S No.",
      dataIndex: "id",
      key: "id",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
      // width:'60px'
    },
    {
      title: "Coupon Code",
      dataIndex: "couponCode",
      key: "couponCode",
      // width:'300px'
      // ellipsis: true
    },
    {
      title: "Expiry Date",
      dataIndex: "expiredAt",
      key: "expiredAt",
      // width:'300px'
      // ellipsis: true
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      // width:'300px'
      // ellipsis: true
    },

    {
      title: "Created By",
      dataIndex: "ownerType",
      key: "ownerType",
      width: 100,
      render: (type) => (type === 1 ? "Salon" : "Admin"),
    },
    {
      title: "Coupon Type",
      dataIndex: "type",
      key: "type",
      width: 100,
      render: (type) => (type === 1 ? "Percentage" : "Fix"),
    },
    {
      title: "Minimum Order Value",
      dataIndex: "minimumOrderValue",
      key: "minimumOrderValue",
      width: 200,
    },

    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",
      render: (status, item) => (
        <Switch
          checked={status === 1}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          onChange={(checked) => handleStatusChange(checked, item)}
        />
      ),
    },

    // {
    //   title: "View Details",
    //   dataIndex: "action",
    //   align: 'center',
    //   key: "action",
    //   render: (_, record) => (
    //     <Space size="middle">
    //       <Tooltip
    //         title="View Details"
    //         style={{ color: "red", cursor: "pointer" }}
    //       >
    //         <span className="action-icon-bg" onClick={() => navigate(`/customers/details/${record.userId}`)}>
    //           <img src={IMAGES.ViewIcon} />
    //         </span>
    //       </Tooltip>
    //     </Space>
    //   ),
    // },

    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {/* <Tooltip title="Edit Details">
            <span
              className="action-icon-bg"
              onClick={() => navigate(`/coupon/edit/${record.id}`)}
            >
              <img src={IMAGES.EditIcon} alt="Edit" />
            </span>
          </Tooltip> */}

          {hasDeletePermission && (
            <Popconfirm
              title="Delete this category?"
              onConfirm={() => handleDelete(record.id)}
              okText="Yes"
              cancelText="No"
            >
              <span className="action-icon-bg">
                <img src={IMAGES.DeleteIcon} alt="Delete" />
              </span>
            </Popconfirm>
          )}
        </Space>
      ),
    },

    // Add other columns as needed
  ];

  const handleChange = (pagination) => {
    setFilter((prev) => ({
      ...prev,
      page: pagination.current, // Update current page from pagination event
    }));
  };

  const resetFilters = () => {
    form.resetFields();
    setFilterForm({});
    setFilter(initialFilter);
  };

  return (
    <>
      <div className="subscription-hea">
        <Row
          gutter={[8, 8]}
          justify="space-between"
          align="middle"
          style={{ marginBottom: "2rem" }}
        >
          <Col>
            <h1 className="app-heading-med">Coupons List</h1>
          </Col>
          <Col style={{ gap: "5px" }}>
            <div style={{ display: "flex", gap: "1rem" }}>
              <Input
                placeholder="Search by name"
                size="large"
                className="FilterSearchBox"
                onChange={(e) =>
                  setFilterForm({ ...filterForm, search: e.target.value })
                }
                value={filterForm?.search}
                style={{ width: "100%" }}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleFilter();
                  }
                }}
              />
              <Button
                onClick={handleFilter}
                type="primary"
                htmlType="submit"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                <SearchOutlined />
              </Button>
              {/* <Button
                onClick={() => showModal()}
                type="primary"
                htmlType="submit"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                <FaSliders />
              </Button> */}
              <Button
                type="primary"
                className="addcity-btn"
                onClick={resetFilters}
                style={{ height: "39px" }}
              >
                Reset
              </Button>
              {hasAddPermission && (
                <Button
                  onClick={() => navigate("/coupons/create")}
                  type="primary"
                  className="addcity-btn"
                  style={{ height: "39px" }}
                >
                  <img src={IMAGES.AddIconFilters} alt="Add" />
                </Button>
              )}
            </div>
          </Col>
        </Row>
        {/* <Row>
          <Search
            placeholder="Search..."
            allowClear
            size="large"
            enterButton="Search"
            className="FilterSearchBox"
            onSearch={onSearch}
            style={{ width: "30%", marginBottom: "20px" }}
          />
        </Row> */}
      </div>

      <Table
        size="middle"
        bordered
        rowClassName={getRowClassName}
        components={components}
        columns={columns(navigate)}
        loading={loading}
        dataSource={filteredCoupons}
        onChange={handleChange}
        pagination={{
          total: totalRecords,
          current: filter?.page,
          pageSize: 10,
          showSizeChanger: false,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
          onChange: (page) => setFilter((prev) => ({ ...prev, page })), // Ensure correct page change
        }}
        scroll={{ x: "max-content" }}
      />

      {/* <CustomersFilter handleFilter={handleFilter} form={form} filterForm={filterForm} setFilterForm={setFilterForm} isModalOpen={isModalOpen} handleCancel={handleCancel} /> */}
    </>
  );
};

export default CouponsList;
